import { useLoginOrSignupPageState } from '#src/app/pages/loginOrSignup/pageContext';
import {
	useCanSubmitForm,
	useLoginOrSignupState,
	useSapCyclingProofExperiment,
} from '#src/app/pages/loginOrSignup/shared/hooks';
import { isLoading } from '#src/app/shared/utils/async';

import { canNavigateForward } from './navigationProps';

type Result = ModelHookResult<
	{
		valid: boolean;
		loading: boolean;
		canNavigateBack: boolean;
		canNavigateForward: boolean;
		hidden: boolean;
	},
	{
		gotoPreviousStep: () => void;
		gotoNextStep: () => void;
	}
>;

export function useLoginOrSignupFooter(): Result {
	const [{ currentStep, stepState, previousStep }, { gotoPreviousStep }] = useLoginOrSignupPageState();
	// TODO: replace useLoginOrSignupState hook with new hook
	const { gotoNextStep } = useLoginOrSignupState();
	const canSubmit = useCanSubmitForm();
	const {
		data: { isTreatment },
	} = useSapCyclingProofExperiment();

	// the V3d treatment moves the email step's Continue into the form, so the footer's is hidden.
	// The email step is never reached with a back action either, so nothing is left to render and
	// the whole footer is dropped — its mobile shell is a fixed, opaque bar that would otherwise
	// cover the bottom of the viewport with nothing in it.
	const suppressedByTreatment = isTreatment && currentStep === 'email';

	return {
		data: {
			valid: canSubmit,
			loading: !!stepState && isLoading(stepState),
			canNavigateBack: !!previousStep,
			// FIXME: canNavigateForward info should come from the state or hook
			canNavigateForward: canNavigateForward(currentStep) && !suppressedByTreatment,
			hidden: suppressedByTreatment,
		},
		actions: {
			gotoPreviousStep,
			gotoNextStep: () => {
				// FIXME not sure why gotoNextStep needs to be async
				// we definitely don't need it to be async in the Footer
				void gotoNextStep();
			},
		},
	};
}
